// extracted by mini-css-extract-plugin
export default {"card":"style_card__EOKQI","container":"style_container__pP3HA","loading":"style_loading__QQ2S1"};